import client from '@/api/client.js';
import store from "@/store";
//import i18n from '@/plugins/i18n.js'
export default {
    methods: {
        async getAllWarehouses() {
            var response = await client().get(store.state.apiRouteRoot + "Store/GetAll", { meta: { clientApiMethod: 'getAllWarehouses' } })
            return response?.data;
        },
        async getStockedWarehouses(articlenr) {
            var meta = { clientApiMethod: 'getStockedWarehouses', input: { articlenr: articlenr } }
            var response = await client().get(store.state.apiRouteRoot + "Store/GetStoresWithStock/" + articlenr, { meta: meta })
            return response?.data;
        },

        async getWareHouseView(warehouseId) {
            var meta = { clientApiMethod: 'getWareHouseView', input: { warehouseId: warehouseId } }
            var response = await client().get(store.state.apiRouteRoot + "Store/StoreArticles/" + warehouseId, { meta: meta })
            return response?.data;
        },

        async getCommonpartsForMyJobs() {
            var meta = { clientApiMethod: 'getCommonpartsForMyJobs', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "Store/CommontPartsForMyJobs/" , { meta: meta })
            return response?.data;
        },

        async getArticlesFromList(list) {
            var meta = { clientApiMethod: 'getArticlesFromList', input: {} }
            var response = await client().post(store.state.apiRouteRoot + "Store/Articles", list, { meta: meta })
            return response?.data;
        },

        async getInventory(query) {
            var meta = { clientApiMethod: 'getInventory', input: { query: query } }
            var response = client().get(store.state.apiRouteRoot + "Inventory/" + query, { meta: meta })
            return response;
        },

        async getInventoryMovements(onlyLocked) {
            var meta = { clientApiMethod: 'getInventoryMovements', input: { onlyLocked: onlyLocked } }
            var query = onlyLocked ? '?onlyLockedLines=true' : ''
            var response = await client().get(store.state.apiRouteRoot + "Inventory/Movements" + query, { meta: meta })
            return response?.data;
        },
    }
}